import React from 'react';
import { getGetNpsCampaignsQueryOptions } from '@area-restrita/api-client/endpoints/nps/nps.gen';

import DataGrid from '@/components/DataGrid';
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import { useQueryTable } from '@/hooks/useQueryTable';
import NpsCampaignFilters from '@/modules/nps/components/NpsCampaignFilters';
import { getErrorMessage } from '@/modules/nps/utils';

import { companyNpsReportColumns } from './columns';

const CompanyNpsReportsTable: React.FC = () => {
  const {
    query: { isError, isLoading, error },
    table,
  } = useQueryTable({
    columns: companyNpsReportColumns,
    getQueryOptions: getGetNpsCampaignsQueryOptions,
  });

  return (
    <>
      {isError && (
        <Alert variant="destructive" className="mb-4">
          <AlertTitle>Erro ao carregar relatórios NPS</AlertTitle>
          <AlertDescription>
            {getErrorMessage(error, 'Tente novamente em instantes.')}
          </AlertDescription>
        </Alert>
      )}

      <DataGrid
        variant="card"
        table={table}
        isLoading={isLoading}
        toolbar={
          <NpsCampaignFilters
            table={table}
            showCompanyFilter={false}
            statuses={['open', 'closed']}
          />
        }
      />
    </>
  );
};

export default CompanyNpsReportsTable;
